
import Vue from "vue";
import AppDepartmentsEdit from "@/components/DepartmentsEdit.vue";
import AppSubscribeToTicketNotifications from "@/components/SubscribeToTicketNotifications.vue";
import AppSettingsAdminPermissions from "@/components/SettingsAdminPermissions.vue";
import { AuthService } from "@/services/auth-service";
import { Admin } from "@/models/admin";
import AppAdminApiKeys from "@/components/AdminApiKeys.vue";
import AppExtraButtons from "@/components/admin/ExtraButtons.vue";

export default Vue.extend({
	data(){
		return {
			admin: AuthService.user as Admin
		};
	},
	components: {
		AppDepartmentsEdit,
		AppSubscribeToTicketNotifications,
		AppSettingsAdminPermissions,
		AppAdminApiKeys,
		AppExtraButtons
	}
});
